/***
 * Created on 2024/2/23
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import {useQnapAuthAppBindCheck} from "../../../../../hook/qnap_auth_app_bind_check";
import {useBoundedStore} from 'common/Store';
import {useTranslation} from "react-i18next";

function QnapAuthCheckStatus({dispatch, state, showPassCode=false, enable=false}) {
    const { t } = useTranslation();
    const {status, device, passcode} = useQnapAuthAppBindCheck(enable);
    const store = useBoundedStore();

    useEffect(() => {
        if (status === 'valid') {
            sessionStorage.removeItem('timer');
            dispatch({type: 'toggleShowSuccess', value: true, device});
        }
        else if (status === 'reject') {
            store.globalAlert.setAlert(t('@Request denied by QNAP Authenticator. Please try sending a new request again.@'), 'error', true);
            dispatch({type: 'toggleShowApproval', value: false});
        }
        else {
            if (!showPassCode && passcode) {
                dispatch({type: 'toggleShowApproval', value: true, device});
            }
        }
        return () => {
            if (showPassCode) {
                sessionStorage.removeItem('timer');
            }
        }
    }, [status, passcode]);

    return (
        <>
            {
                showPassCode &&
                <p className="two-step--verify__action__code !text-48 !line-height-normal">{passcode}</p>
            }
        </>
    );
}

export default QnapAuthCheckStatus;